/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './misc-charges.reducer';

export const MiscChargesDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const miscChargesEntity = useAppSelector(state => state.miscCharges.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="miscChargesDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.miscCharges.detail.title">MiscCharges</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.miscCharges.id">Id</Translate>
            </span>
          </dt>
          <dd>{miscChargesEntity.id}</dd>
          <dt>
            <span id="chargeName">
              <Translate contentKey="tinyMedicRestApp.miscCharges.chargeName">Charge Name</Translate>
            </span>
          </dt>
          <dd>{miscChargesEntity.chargeName}</dd>
          <dt>
            <span id="chargeCode">
              <Translate contentKey="tinyMedicRestApp.miscCharges.chargeCode">Charge Code</Translate>
            </span>
          </dt>
          <dd>{miscChargesEntity.chargeCode}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.miscCharges.active">Active</Translate>
            </span>
          </dt>
          <dd>{miscChargesEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.miscCharges.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{miscChargesEntity.cursor}</dd>
          <dt>
            <span id="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.miscCharges.lastUpdated">Last Updated</Translate>
            </span>
          </dt>
          <dd>{miscChargesEntity.lastUpdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.miscCharges.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{miscChargesEntity.microSec}</dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.miscCharges.timestampEntry">Timestamp Entry</Translate>
            </span>
          </dt>
          <dd>{miscChargesEntity.timestampEntry}</dd>
          <dt>
            <span id="chargeAmount">
              <Translate contentKey="tinyMedicRestApp.miscCharges.chargeAmount">Charge Amount</Translate>
            </span>
          </dt>
          <dd>{miscChargesEntity.chargeAmount}</dd>
          <dt>
            <span id="taxPercent">
              <Translate contentKey="tinyMedicRestApp.miscCharges.taxPercent">Tax Percent</Translate>
            </span>
          </dt>
          <dd>{miscChargesEntity.taxPercent}</dd>
          <dt>
            <span id="startDate">
              <Translate contentKey="tinyMedicRestApp.miscCharges.startDate">Start Date</Translate>
            </span>
          </dt>
          <dd>{miscChargesEntity.startDate}</dd>
          <dt>
            <span id="endDate">
              <Translate contentKey="tinyMedicRestApp.miscCharges.endDate">End Date</Translate>
            </span>
          </dt>
          <dd>{miscChargesEntity.endDate}</dd>
          <dt>
            <span id="suspended">
              <Translate contentKey="tinyMedicRestApp.miscCharges.suspended">Suspended</Translate>
            </span>
          </dt>
          <dd>{miscChargesEntity.suspended ? 'true' : 'false'}</dd>
          <dt>
            <span id="draft">
              <Translate contentKey="tinyMedicRestApp.miscCharges.draft">Draft</Translate>
            </span>
          </dt>
          <dd>{miscChargesEntity.draft ? 'true' : 'false'}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.miscCharges.hospital">Hospital</Translate>
          </dt>
          <dd>{miscChargesEntity.hospital ? miscChargesEntity.hospital.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/misc-charges" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/misc-charges/${miscChargesEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default MiscChargesDetail;
